import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "currentColor",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M4.667.542a.75.75 0 0 1 .75.75V2h5.167v-.708a.75.75 0 0 1 1.5 0V2h1.333a2 2 0 0 1 2 2v10.833a2 2 0 0 1-2 2H2.584a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1.333v-.708a.75.75 0 0 1 .75-.75m0 2.958H2.584a.5.5 0 0 0-.5.5v1.75h11.833V4a.5.5 0 0 0-.5-.5h-8.75m9.25 3.75H2.084v7.583a.5.5 0 0 0 .5.5h10.833a.5.5 0 0 0 .5-.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }